// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import {getFirestore} from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA0_iMe-8GvUq7q2ZHRQGGbc8wlMbOluY8",
  authDomain: "email-campaign-db2bc.firebaseapp.com",
  projectId: "email-campaign-db2bc",
  storageBucket: "email-campaign-db2bc.appspot.com",
  messagingSenderId: "23968135555",
  appId: "1:23968135555:web:9e613548514d5436c35eb6"
};

initializeApp(firebaseConfig);
const messaging  = getMessaging();

export const RequestForToken = async () => {
    return await getToken(messaging, { vapidKey: "BJWEforl-piP9_KCqFQV2uX5QP2HrjZiZmt5E8yE4gWSUmhhOCIcGZnAZr3y-ei-r1EkWTyy_8Mv3zzvq6csT58" })
      .then((currentToken) => {
        if (currentToken) {
          console.log('current token for client: ', currentToken);
          // Perform any other neccessary action with the token
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.======>');
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
  };

  export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("payload", payload)
      resolve(payload);
    });
  });